import type { Router } from '@angular/router';
import {
  addMutationPropagators as addEscrowMutationPropagators,
  addPushTransformers as addEscrowPushTransformers,
  addSearchTransformers as addEscrowSearchTransformers,
  addUpdateTransformers as addEscrowUpdateTransformers,
  datastoreFunctions as escrowDatastoreFunctions,
} from '@escrow/datastore/collections-testing';
import type { AuthServiceInterface } from '@freelancer/auth/interface';
import type { DatastoreInterface } from '@freelancer/datastore/core';
import type {
  DatastoreInitializer,
  DatastoreTestingController,
} from '@freelancer/datastore/testing';
import { publishDatastoreCollectionFactoryFunctions } from '@freelancer/datastore/testing';
import { datastoreFunctions } from './datastore-functions';
import {
  printState,
  setAuth,
  setDatastoreController,
} from './document-creators';
import { constructInitialStoreState } from './initial-states';
import { addMutationPropagators } from './mutation-propagators';
import { addPushTransformers } from './push-transformers';
import { addSearchTransformers } from './search-transformers';
import { addUpdateTransformers } from './update-transformers';

export function datastoreInitializer({
  isTesting = false,
  blankState = false,
  appName,
}: {
  readonly isTesting?: boolean;
  readonly blankState?: boolean;
  readonly appName?: string;
} = {}): DatastoreInitializer {
  return async (
    auth: AuthServiceInterface,
    datastore: DatastoreInterface,
    datastoreController: DatastoreTestingController,
    router: Router,
  ) => {
    setAuth(auth);
    setDatastoreController(datastoreController);

    publishDatastoreCollectionFactoryFunctions(
      appName === 'escrow' ? escrowDatastoreFunctions : datastoreFunctions,
      datastoreController.platformId,
    );

    if (appName === 'escrow') {
      addEscrowTransformers();
    } else {
      addDefaultTransformers();
    }

    /** If we're not running a UI or other type of test, set up the state */
    if (!isTesting) {
      await constructInitialStoreState(
        auth,
        datastore,
        datastoreController,
        router,
        blankState,
      );
      printState();
    }
  };
}

function addDefaultTransformers(): void {
  addPushTransformers();
  addMutationPropagators();
  addSearchTransformers();
  addUpdateTransformers();
}

function addEscrowTransformers(): void {
  addEscrowPushTransformers();
  addEscrowMutationPropagators();
  addEscrowUpdateTransformers();
  addEscrowSearchTransformers();
}
